import { Space, Typography, Table } from 'antd'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import {TableLoader } from '../../shared'
import { ActionButton } from '../'
import { EyeOutlined } from '@ant-design/icons'
import { ViewPRPSessionDetail } from '../'
import { priorityLookup, } from '../../shared'
import "./index.css"
const { Title } = Typography

const PrpSessions = ({ title, data, isDashboardPRP, tomorrow }) => {
  const { loading } = useSelector(state => state?.dashboard)
  const [state, setState] = useState([])
  const [visibleViewModal, setVisibleViewModal] = useState(false)
  const [viewData, setViewData] = useState(false)
  useEffect(() => {
    if (data?.length) {
      let temp = data?.map(row => ({
        ...row,
        clientPriority: {
          id: parseInt(row?.clientPriority),
          name: priorityLookup?.findIndex(fin => fin?.id === parseInt(row?.clientPriority)).name
        }
      }))
      setState([...temp])
    }
  }, [data])
  const columns = [
    {
      title: 'Name',
      dataIndex: 'Client_info',
      render: col => col?.name
    },
    {

      title: 'Phone',
      dataIndex: 'Client_info',
      render: col => col?.telephone
    },
    {
      title: 'Action',
      dataIndex: 'action',
      render: (data, row) => (
        <ActionButton
          title='view appointment'
          icon={<EyeOutlined />}
          onClick={() => { setVisibleViewModal(true); setViewData(row) }}
        />
      )
    },
  ]
  return (
    <Space
      direction="vertical"
      className="border-grey"
      style={{ width: '100%', borderRadius: '3px'}}
    >
      <Title level={5} className='prp-bg px-3 py-2'>
        {
          title
        }
      </Title>
      <div className='px-3 py-2'>
        <Table
          columns={columns}
          dataSource={state}
          loading={
            {
              ...TableLoader,
              spinning: loading
            }
          }
          pagination={false}
          size='small'
          className='table-scroll'
        />
      </div>
      <ViewPRPSessionDetail
        visible={visibleViewModal}
        data={viewData}
        onClose={() => { setVisibleViewModal(false); setViewData(null) }}
        isDashboardPRP
      />
    </Space>
  )
}
export { PrpSessions }